import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";

/**
 * GenerateServicosProdutosColumnDefinition
 */

type Props = {
  onActionEditar: (idProdutoServico: number | null, openState: boolean) => void;
  onActionDelete: (idProdutoServico: number | null, openState: boolean) => void;
};

export const GenerateServicosProdutosColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {

  const computeStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  // Tipo

  const computeTipoTitle = (tipo: string) => {
    switch (tipo) {
      case 'P':
        return "Produto";
      case 'S':
        return "Serviço";
      default:
        return "?";
    }
  };

  const computeTipoColor = (tipo: string) => {
    switch (tipo) {
      case 'P':
        return "green";
      case 'S':
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeTipoDescription = (tipo: string) => {
    switch (tipo) {
      case 'P':
        return "Produto";
      case 'S':
        return "Serviço";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 70,
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeStatusTitle(params.value ? 1 : 0)}
            color={computeStatusColor(params.value ? 1 : 0)}
            description={computeStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      minWidth: 120,
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoTitle(params.value)}
            color={computeTipoColor(params.value)}
            description={computeTipoDescription(params.value)} />
        </div>
      )
    },
    {
      field: "nrProdutoServico",
      filterable: false,
      headerName: "Código",
      minWidth: 150,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Produto/Serviço",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 150,
      sortable: false,
    },
    {
      field: "norma",
      filterable: false,
      headerName: "Norma",
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'idProdutoServico',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}